<template>
    <div 
        v-show="isMobileMenuOpened"
        class="mobileMenuDisplay"
    >
        <ul class="mobileMenuContainer">
            <v-container class="mobileMenuView">
                <v-row>
                    <v-col 
                        class="p-0"
                        md="6"
                        sm="6"
                        cols="12"
                    >
                        <menu_item
                            itemTitle="Cyber Corner"
                            itemRoute="cyber-corner"
                            :isSubItemsListOpened="selectedMainMenuTitle === 'Cyber Corner'"
                            @close-mobile-menu="closeMobileMenu"
                            @close-all-sub-menus="closeAllSubMenuItems"
                        />

                        <menu_item
                            itemTitle="Courses/Videos"
                            :subItemList="[
                                { subItemTitle: 'Online Courses', subItemRoute: 'online-courses' },
                                // { subItemTitle: 'Pillars of Knowledge', subItemRoute: 'pillars-of-knowledge' },
                                { subItemTitle: 'Informational Videos', subItemRoute: 'information-videos' },
                            ]"
                            :isSubItemsListOpened="selectedMainMenuTitle === 'Courses/Videos'"
                            @close-mobile-menu="closeMobileMenu"
                            @close-all-sub-menus="closeAllSubMenuItems"
                            @send-menuItem-announcement="createAnnouncementText"
                        />

                        <menu_item
                            itemTitle="Events"
                            itemRoute="events"
                            :isSubItemsListOpened="selectedMainMenuTitle === 'Events'"
                            @close-mobile-menu="closeMobileMenu"
                            @close-all-sub-menus="closeAllSubMenuItems"
                        />

                        <!--TEMPORARILY REMOVE THE PARTNERS MENU -->
                        <!-- <menu_item
                            itemTitle="Partners"
                            :subItemList="[
                                { subItemTitle: 'Our Partners', subItemRoute: 'partners' },
                                { subItemTitle: 'CMMC', subItemRoute: 'about-cmmc' },
                                { subItemTitle: 'MEP', subItemRoute: 'mep', isItemVisible: !isIndividual },
                                { subItemTitle: 'SBA', subItemRoute: 'small-business-administration', isItemVisible: !isIndividual },
                                { subItemTitle: 'MPP Pilot', subItemRoute: 'pilot-program', isItemVisible: !isIndividual },
                            ]"
                            :isSubItemsListOpened="selectedMainMenuTitle === 'Partners'"
                            @close-mobile-menu="closeMobileMenu"
                            @close-all-sub-menus="closeAllSubMenuItems"
                        /> -->
                    </v-col>
                    <v-col 
                        class="p-0"
                        md="6"
                        sm="6"
                        cols="12"
                    >
                        <menu_item
                            itemTitle="Info Hub"
                            :subItemList="[
                                // { subItemTitle: 'Latest News', subItemRoute: 'news' },
                                { subItemTitle: 'White Papers', subItemRoute: 'white-papers' },
                                { subItemTitle: 'Policy Corner', subItemRoute: 'policy-corner' },
                                { subItemTitle: 'Client Templates', subItemRoute: 'client-templates' },
                            ]"
                            :isSubItemsListOpened="selectedMainMenuTitle === 'Info Hub'"
                            @close-mobile-menu="closeMobileMenu"
                            @close-all-sub-menus="closeAllSubMenuItems"
                        />

                        <menu_item
                            itemTitle="Resources"
                            :subItemList="[
                                { subItemTitle: 'Cyber Self Assessments', subItemRoute: 'cyber-readiness-check' },
                                // { subItemTitle: 'Cyber Readiness Training', subItemRoute: 'cyber-readiness-check-training' },
                                { subItemTitle: 'Products & Services', subItemRoute: 'tool-list' },
                                { subItemTitle: 'Useful Links & Resources', subItemRoute: 'useful-links' },
                            ]"
                            :isSubItemsListOpened="selectedMainMenuTitle === 'Resources'"
                            @close-mobile-menu="closeMobileMenu"
                            @close-all-sub-menus="closeAllSubMenuItems"
                        />

                        <menu_item
                            itemTitle="Speaker Request"
                            itemRoute="speaker-request"
                            :isSubItemsListOpened="selectedMainMenuTitle === 'Speaker Request'"
                            @close-mobile-menu="closeMobileMenu"
                            @close-all-sub-menus="closeAllSubMenuItems"
                        />

                        <menu_item
                            v-if="isLoggedIn"
                            itemTitle="My Account"
                            :subItemList="[
                                { subItemTitle: 'User Profile', subItemRoute: 'my-account', },
                                { subItemTitle: 'My Dashboard', subItemRoute: 'dashboard', },
                                // { subItemTitle: 'Sign Up', subItemRoute: 'signup', isItemVisible: !isLoggedIn },
                                // { subItemTitle: 'Login', subItemRoute: 'login', isItemVisible: !isLoggedIn },
                                { subItemTitle: 'Logout', subItemRoute: 'logout', },
                            ]"
                            :isSubItemsListOpened="selectedMainMenuTitle === 'My Account'"
                            @close-mobile-menu="closeMobileMenu"
                            @close-all-sub-menus="closeAllSubMenuItems"
                        />
                        <menu_item
                            v-else
                            itemTitle="Sign In/Register"
                            itemRoute="login"
                            :isSubItemsListOpened="selectedMainMenuTitle === 'Sign In/Register'"
                            @close-mobile-menu="closeMobileMenu"
                            @close-all-sub-menus="closeAllSubMenuItems"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </ul>
    </div>
</template>

<script>
    import menu_item from "./mobileMenuItem";

    export default {
        props: {
            isMobileMenuOpened: Boolean,
            isLoggedIn: Boolean,
            isIndividual: Boolean,
            activeMenuItem: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                selectedMainMenuTitle: null,
            };
        },
        components: {
            menu_item,
        },
        methods: {
            closeMobileMenu() {
                // TO REMOVE THE MOBILE MENU AFTER A MENU ITEM OR SUB-MENU ITEM HAS BEEN CLICKED ON
                this.$emit("close-mobile-menu-view", false);
            },
            closeAllSubMenuItems(mainMenuTitle) {
                // TO CLOSE ALL THE OTHER SUB MENU ITEMS EXCEPT THAT OF THE MAIN MENU ITEM THAT WAS CLICKED ON
                this.selectedMainMenuTitle = mainMenuTitle;
            },
            createAnnouncementText(announcementSublect) {
                this.closeMobileMenu();
                this.$emit("send-announcement-text", announcementSublect);
            },
        },
        watch: {
            activeMenuItem(newValue) {
                switch(newValue) {
                    case "Cyber Corner":
                        this.selectedMainMenuTitle = "Cyber Corner";
                        return;
                    case "Courses/Videos":
                        this.selectedMainMenuTitle = "Courses/Videos";
                        return;
                    case "Events":
                        this.selectedMainMenuTitle = "Events";
                        return;
                    case "Partners":
                        this.selectedMainMenuTitle = "Partners";
                        return;
                    case "Info Hub":
                        this.selectedMainMenuTitle = "Info Hub";
                        return;
                    case "Resources":
                        this.selectedMainMenuTitle = "Resources";
                        return;
                    case "Speaker Request":
                        this.selectedMainMenuTitle = "Speaker Request";
                        return;
                    case "Sign In/Register":
                    case "My Account":
                        this.selectedMainMenuTitle = newValue;
                        return;
                    default:
                        this.selectedMainMenuTitle = null;
                };
            }
        }
    }
</script>

<style scoped>
.mobileMenuDisplay {
	position: fixed;
	top: 80px;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 5000;
	background-color: #001426;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    min-width: 350px;
}

.mobileMenuContainer {
    width: 100%;
    height: auto;
    margin-top: 40px;
}

.mobileMenuView {
    width: 100%;
    height: auto;
    max-height: 500px;
    overflow-y: scroll;
}

.mobileMenuContainer li {
    text-align: center;
    list-style-type: none;
    font-family: Rajdhani;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 30px;
}
</style>